<template>
    <div>
        <div class="div-404">
            <img v-show="zhactive" @click="changeIndex()" src="@/assets/images/index-svg-black.svg" alt="">
            <img v-show="enactive" @click="changeIndex()" src="@/assets/images/index-svg-black-en.svg" alt="">
        </div>
        <div class="div_content-404">
            <img src="@/assets/images/404.svg" alt="">
            <h1>Not Found (#404)</h1>
            <p>{{msg}}</p>
            <div class="div_click_home" @click="changeIndex()">{{$t('lang.go_home')}}</div>
            <div class="div_click_cs">
                <div><a href="javascript:;">{{$t('lang.Record_1')}}</a></div>
                <div>&nbsp;&nbsp;&nbsp;</div>
                <div><a href="https://beian.miit.gov.cn" target="_blank">{{$t('lang.Record_2')}}</a></div>
            </div>
            <p>
                <!-- <div></div> -->
                <!--  -->
            </p>
        </div>
    </div>
</template>
<script>
import {mapGetters} from "vuex"
import {Localurl} from "@/utils/validate"
export default {
    name:'errors',
    computed:{
        ...mapGetters(["languageType"])
    },
    data(){
        return{
            zhactive:true,
            enactive:false,
            msg:'',
        }
    },
    mounted() {
        this.msg= this.$route.params.id
        Localurl("?lang="+this.languageType);
        if(this.languageType == 'zh'){
            this.zhactive = true
            this.enactive = false
            document.title = "404"
        }else{
            this.enactive = true
            this.zhactive = false
            document.title = "404"
        }
    },
    methods:{
        changeIndex(){this.$router.push({path:'/index',query:{lang:this.languageType}})},
    }

    
}
</script>
<style>
.div-404{
    width: 100%;
    height: 100px;
    transition: .6s all ease-in-out;
    padding: 0 30px;
    font-size: 2rem;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.125);
}
.div-404 img{
    height: 60px;
    width: 100%;
}
.div_content-404{
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    align-items: center;
    height:calc(100vh - 100px);
}
.div_content-404 img{
    width:280px;
}
.div_content-404 h1{
    font-size: 60px;
    color: #666666;
    padding: 20px 0;
}
.div_click_home{
    height: 80px;
    width: 50%;
    text-align: center;
    line-height: 80px;
    border-top:1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6; 
    cursor: pointer;
}
.div_click_cs{
    width: 50%;
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 30px 0;  
}
.div_click_cs div a{
color: #999999;
}
.div_click_cs div:nth-child(3) a:hover{
color: #858585;
}
@media (max-width:768px){
    .div_content-404 img{
        width:220px;
    }
    .div_click_cs{
        padding: 25px 0;  
    }
    .div_content-404 h1{
        font-size: 45px;
        color: #666666;
        padding: 15px 0;
    }
    .div_click_home{
        height:60px;
        line-height: 60px;
    }
    .div_click_cs{
        width: 100%;
        padding: 25px 0;  
    }

}
@media (max-width:468px){
    .div_content-404 img{
        width:180px;
    }
    .div_click_cs{
        padding: 20px 0;  
    }
    .div_content-404 h1{
        font-size: 36px;
        color: #666666;
        padding: 15px 0;
    }
    .div_click_home{
        height:60px;
        line-height: 60px;
    }
    .div_click_cs{
        width: 100%;
        padding: 25px 0;  
    }

}
</style>

